module.exports = __webpack_public_path__ + "media/images/admin/icons/activity-24e13b02f43c5d60dddc9dc4d4fcbcfc.svg";